module.exports = __webpack_public_path__ + "media/einfach-weiterklicken.d6953b4c.mp3";